
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recorded-training",
      function () {
        return require("private-next-pages/recorded-training/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recorded-training"])
      });
    }
  